import { PageType } from '../enums/pages/page-type.enum';
import {
  ActionRequestDto,
  CheckoutActionRequestDto,
  UserRequestDto,
} from './abstract-action.dto';

export class AbstractRequestDto {
  pageUri: string;
  pageType: PageType;
  requestId: string;

  checkoutContext: CheckoutActionRequestDto;

  actionContext: ActionRequestDto;

  pincodeContext: ActionRequestDto;

  userContext: UserRequestDto;
}
